import httpClient from './http-client'

export interface ImpersonationSession {
  session_id: string
  access_token: string
  refresh_token: string
  expires_in?: number
  /** 'limited' = support view (no Gmail/Outlook content); 'full' = backed by an email-access grant. */
  access_mode?: 'limited' | 'full'
  user: {
    id: string
    email: string
    name: string
  }
}

export const impersonationApi = {
  start: (userId: string, reason?: string) =>
    httpClient.post<ImpersonationSession>(`/lightbase/impersonate/${userId}`, {
      reason: reason || undefined,
    }),
  end: (sessionId: string) =>
    httpClient.post('/lightbase/impersonate/end', { session_id: sessionId }),
}
